export default __webpack_public_path__ + "static/maintain-ai-dark-414728a730954c19f90a4132b5fbbf1f.png";